import request from '../utils/request'
import type { SysRole } from '../types/models'

export interface SysPermissionRecord {
  id: string
  permission_code: string
  permission_name: string
  permission_group?: string
  description?: string
  status: number
}

export function getRoleList() {
  return request.get<SysRole[]>('/auth/role/list')
}

export function createRole(data: Partial<SysRole>) {
  return request.post<SysRole>('/auth/role', data)
}

export function updateRole(data: Partial<SysRole>) {
  return request.put<SysRole>('/auth/role', data)
}

export function deleteRole(id: string | number) {
  return request.delete<boolean>(`/auth/role/${id}`)
}

export function getPermissionList() {
  return request.get<SysPermissionRecord[]>('/auth/permission/list')
}
